var exports = {
  "kL": "x2b2fbebb--467872--container",
  "HU": "x2b2fbebb--467872--aside",
  "iW": "x2b2fbebb--467872--main",
  "n2": "x2b2fbebb--467872--main-heading",
  "Pf": "x2b2fbebb--467872--label",
};

module.exports = exports;
